'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _components = require('../../components');

var _reactIntl = require('react-intl');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CardCta = require('./CardCta.scss');

var _CardCta2 = _interopRequireDefault(_CardCta);

var _WhyCantRetractBidPopover = require('../../components/Popovers/WhyCantRetractBidPopover');

var _WhyCantRetractBidPopover2 = _interopRequireDefault(_WhyCantRetractBidPopover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardCta = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(CardCta, _Component);

    function CardCta() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CardCta);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CardCta.__proto__ || (0, _getPrototypeOf2.default)(CardCta)).call.apply(_ref, [this].concat(args))), _this), _this.openBidModal = function () {
            _this.props.openAbstenteeBidModal(_this.props.item.itemId, 0);
        }, _this.openRetractBidModal = function () {
            _this.props.openRetractBidModal(_this.props.item.itemId);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CardCta, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['currency', 'catalogStatus', 'catalogId', 'itemUrl']) || (0, _propsComparer2.default)(this.props.item, nextProps.item, ['isAvailable', 'isPassed']) || (0, _propsComparer2.default)(this.props.biddingInfo, nextProps.biddingInfo, ['bidderHasHighBid', 'isReserveMet', 'bidderMaxBid']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                biddingInfo = _props.biddingInfo,
                catalogId = _props.catalogId,
                catalogRegistration = _props.catalogRegistration,
                catalogStatus = _props.catalogStatus,
                currency = _props.currency,
                itemUrl = _props.itemUrl,
                showSendSellerMessageModal = _props.showSendSellerMessageModal;
            var blockedByAuctioneer = catalogRegistration.blockedByAuctioneer,
                declined = catalogRegistration.declined,
                suspended = catalogRegistration.suspended;
            var bidderHasHighBid = biddingInfo.bidderHasHighBid,
                bidderMaxBid = biddingInfo.bidderMaxBid,
                isReserveMet = biddingInfo.isReserveMet;


            if (!bidderMaxBid) {
                return null;
            }

            var buttonProps = {
                primary: !bidderHasHighBid || !isReserveMet,
                secondary: bidderHasHighBid && isReserveMet,
                small: true
            };

            var bidAmount = (0, _jsx3.default)(_reactIntl.FormattedNumber, {
                currency: currency,
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
                style: 'currency',
                value: bidderMaxBid
            });

            var button = '';
            if (blockedByAuctioneer || suspended) {
                buttonProps.primary = true;
                buttonProps.secondary = false;
                button = _react2.default.createElement(
                    _components.ButtonLink,
                    (0, _extends3.default)({
                        external: true,
                        url: 'http://liveauctioneers.desk.com/',
                        className: _CardCta2.default['help-button']
                    }, buttonProps),
                    (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'help_center'
                    })
                );
            } else if (declined) {
                buttonProps.primary = true;
                buttonProps.secondary = false;
                button = (0, _jsx3.default)(_components.ShouldLogInContainer, {
                    requireLogin: true,
                    requireCompleteProfile: true,
                    runFunction: showSendSellerMessageModal
                }, void 0, _react2.default.createElement(
                    _components.Button,
                    (0, _extends3.default)({}, buttonProps, { className: _CardCta2.default.button }),
                    (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'contact_auctioneer'
                    })
                ));
            } else if (catalogStatus === 'done') {
                buttonProps.primary = true;
                buttonProps.secondary = false;
                button = _react2.default.createElement(
                    _components.ButtonLink,
                    (0, _extends3.default)({ url: itemUrl, className: _CardCta2.default.button }, buttonProps),
                    (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'view_similar_items'
                    })
                );
            } else if (catalogStatus === 'live') {
                buttonProps.secondary = true;
                button = (0, _jsx3.default)(_components.BidConsoleOpener, {
                    catalogId: catalogId
                }, void 0, _react2.default.createElement(
                    _components.Button,
                    (0, _extends3.default)({ className: _CardCta2.default.button + ' ' + _CardCta2.default.live }, buttonProps),
                    (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'enter_live_auction'
                    })
                ));
            } else {
                button = _react2.default.createElement(
                    _components.Button,
                    (0, _extends3.default)({ className: _CardCta2.default.button }, buttonProps, { onClick: this.openBidModal }),
                    bidderHasHighBid ? (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'increase_max_of',
                        values: { bidAmount: bidAmount }
                    }) : (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                        id: 'increase_bid_of',
                        values: { bidAmount: bidAmount }
                    })
                );
            }

            var retractButton = void 0;
            if (catalogStatus === 'done') {
                retractButton = (0, _jsx3.default)('span', {
                    disabled: true,
                    className: _CardCta2.default.retract
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'retract'
                }));
            } else if (catalogStatus === 'live') {
                retractButton = (0, _jsx3.default)('span', {
                    className: _CardCta2.default.retract
                }, void 0, (0, _jsx3.default)(_WhyCantRetractBidPopover2.default, {
                    id: 'whyCantRetractBidPopover',
                    styles: _CardCta2.default
                }));
            } else {
                retractButton = (0, _jsx3.default)('span', {
                    className: _CardCta2.default.retract,
                    onClick: this.openRetractBidModal
                }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                    id: 'retract'
                }));
            }

            return (0, _jsx3.default)('div', {
                className: _CardCta2.default['item-card-control']
            }, void 0, button, retractButton);
        }
    }]);
    return CardCta;
}(_react.Component), _class.defaultProps = {
    biddingInfo: {
        bidderMaxBid: 0
    },
    catalogRegistration: {
        blockedByAuctioneer: false,
        declined: false,
        suspended: false
    },
    catalogStatus: '',
    currency: 'USD',
    item: {}
}, _temp2);
exports.default = CardCta;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemCard/CardCta.js
// module id = YgC6
// module chunks = 46